import React from 'react';
import PropTypes from 'prop-types';
import TruncatedEllipsis from '../shared/truncated-ellipsis';
import ErrorBoundary from '../../shared/error-boundary';

const ReadMore = ({ url, readmoreClickHandler, wireId }) => {
  if (readmoreClickHandler) {
    return (<a href={url} onClick={readmoreClickHandler} className="show-more">&nbsp;Read More</a>);
  }

  return (
    <a
      href={url}
      data-controller="event"
      data-event-name-value="link_click"
      data-event-id-value={wireId}
      data-event-statisticable-value="wire"
      className="show-more"
    >
&nbsp;Read More
    </a>
  );
};

ReadMore.propTypes = {
  url: PropTypes.string.isRequired,
  readmoreClickHandler: PropTypes.func,
  wireId: PropTypes.number,
};

ReadMore.defaultProps = {
  readmoreClickHandler: null,
  wireId: 0,
};

const FullSummary = ({
  summary,
  showMoreLink,
  url,
  readmoreClickHandler,
  wireId,
}) => (
  <span className="full-summary">
    {summary}
    {!!showMoreLink
      && <ReadMore url={url} readmoreClickHandler={readmoreClickHandler} wireId={wireId} />}
  </span>
);

FullSummary.propTypes = {
  summary: PropTypes.string.isRequired,
  showMoreLink: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  readmoreClickHandler: PropTypes.func,
  wireId: PropTypes.number,
};

FullSummary.defaultProps = {
  readmoreClickHandler: null,
  wireId: 0,
};

const ClampedSummary = ({
  summary,
  url,
  lines,
  showMoreLink,
  readmoreClickHandler,
  wireId,
}) => (
  <span className="clampped-summary">
    <TruncatedEllipsis lines={lines || 2} summary={summary} />
    {showMoreLink && (
      <ReadMore url={url} readmoreClickHandler={readmoreClickHandler} wireId={wireId} />
    )}
  </span>
);

ClampedSummary.propTypes = {
  summary: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  lines: PropTypes.number,
  showMoreLink: PropTypes.bool,
  readmoreClickHandler: PropTypes.func,
  wireId: PropTypes.number,
};

ClampedSummary.defaultProps = {
  lines: null,
  showMoreLink: false,
  readmoreClickHandler: null,
  wireId: 0,
};

const WireSummary = ({ allowFullSummary, ...props }) => (
  <ErrorBoundary>
    <p className="wire__summary" data-id="summarized-body">
      {!!allowFullSummary && <FullSummary {...props} />}
      <ClampedSummary {...props} />
    </p>
  </ErrorBoundary>
);

WireSummary.propTypes = {
  allowFullSummary: PropTypes.bool,
};

WireSummary.defaultProps = {
  allowFullSummary: true,
};

export default WireSummary;
